<template>
  <v-menu min-width="250" bottom left>
    <template v-slot:activator="{ on }">
      <v-btn icon dark v-on="on">
        <v-avatar v-if="hasProfile && profile.avatar" size="32px">
          <img v-if="profile.avatar" :src="profile.avatar" />
        </v-avatar>
        <v-icon v-else v-text="$vuetify.icons.values.user"></v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list>
        <v-list-item v-if="hasProfile">
          <v-list-item-avatar>
            <img :src="profile.avatar" v-if="profile.avatar" />
            <v-icon v-else v-text="$vuetify.icons.values.user"></v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ profile.display }}</v-list-item-title>
            <v-list-item-subtitle>{{ profile.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-item :to="{ name: 'me' }">
          <v-list-item-title>{{ $t('profile') }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn block color="accent" @click="signout" depressed>{{ $t('signout') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { NAMESPACE } from '../store'

export default {
  computed: {
    ...mapState(NAMESPACE, ['profile']),
    ...mapGetters(NAMESPACE, ['locale']),
    hasProfile() {
      return !!this.profile
    }
  },
  watch: {
    locale: function (v) {
      this.setLocale(v)
    }
  },
  methods: {
    signout() {
      // XXX: Maybe this belongs in the auth module, but we don't yet have a
      // UI element to hook it to that makes sense.
      this.$store.dispatch('auth/signout').then(() => {
        this.$router.push('/signin')
      })
    },
    setLocale(v) {
      // Since this is always loaded, it's a good place to
      // add the switcher logic
      if (v) {
        this.$root.$i18n.locale = v
      }
    }
  },
  created() {
    this.setLocale(this.locale)
  }
}
</script>

<i18n>
{
  "en": {
    "profile": "@:labels.profile",
    "signout": "@:labels.signout"
  },
  "fr": {
    "profile": "@:labels.profile",
    "signout": "@:labels.signout"
  }
}
</i18n>
